// Root type
export const AUTHENTICATION_ROOT = 'authentication/';

// Actions types
export const LOGIN_BY_PASSWORD = 'loginByPassword';
export const LOGIN_BY_PASSWORD_NO_INDEX = 'loginByPasswordNoIndex';
export const CHANGE_EXPIRED_PASSWORD = 'changePassword';
export const GENERATE_OTP = 'generateOtp';
export const LOGIN_BY_OTP = 'loginByOtp';
export const RESET_PASSWORD = 'resetPassword';
export const SEND_FORGOT_PASSWORD_MAIL = 'sendForgotPasswordMail';
export const SSO_LOGIN = 'ssoLogin';
export const OIDC_SSO_LOGIN = 'oidcSsoLogin';
export const GET_OIDC_USER_MANAGER = 'getOidcUserManager';

// Getters types
export const USER_DETAILS = 'userDetails';
export const AUTH_LOADING_MODE = 'loadingMode';
export const AUTH_ERRORS = 'authErrors';
export const OTP_SENT = 'otpSent';
export const SMS_SENDING = 'smsSending';
export const GOV = 'gov';
export const SELECT_AUTH_METHOD_ERRORS = 'selectAuthMethodErrors';
export const LAST_SSO_USED_TOKEN = 'lastSsoUsedToken';
export const IS_RECAPTCHA_V2_USED = 'isRecaptchaV2Used';
export const OIDC_ID = 'oidcId';
export const OIDC_USER_MANAGER = 'oidcUserManager';

// Mutations types
export const SET_AUTH_LOADING_MODE = 'setLoadingMode';
export const SET_AUTH_ERRORS = 'setAuthErrors';
export const SET_USER_DETAILS = 'setUserDetails';
export const SET_OTP_SENT = 'setOtpSent';
export const SET_GOV = 'setGov';
export const AUTHENTICATION_RESET_STATE = 'authenticationResetState';
export const SET_SMS_SENDING = 'setSmsSending';
export const SET_SELECT_AUTH_METHOD_ERRORS = 'setSelectAuthMethodErrors';
export const SET_LAST_SSO_USED_TOKEN = 'setLastSsoUsedToken';
export const SET_IS_RECAPTCHA_V2_USED = 'setIsRecaptchaV2Used';
export const SET_OIDC_ID = 'setOidcId';
export const SET_OIDC_USER_MANAGER = 'setOidcUserManager';

